import React, { ReactElement } from 'react';
import ChoiceOption from '@/components/ChoiceOption';
import './TrueFalse.scss';
import {
  TrueFalsePropDataType,
  TrueFalsePropType,
} from '@/modules/types/choice';

export const TrueFalseChoices: TrueFalsePropType[] = [
  {
    data: {
      content: 'True',
      value: 1,
    },
  },
  {
    data: {
      content: 'False',
      value: 0,
    },
  },
];

const TrueFalse = ({
  isDisabled,
  handler,
}: {
  isDisabled: boolean;
  handler: (answer: string) => void;
}): ReactElement => {
  const selectTrueFalse = (choice: TrueFalsePropDataType) => {
    handler(`${choice.value}`);
  };
  return (
    <div id="TrueFalse" className="elmoca-truefalse">
      {TrueFalseChoices.map((item: TrueFalsePropType, index: number) => (
        <ChoiceOption
          key={index}
          iconRight={false}
          title=""
          description={item.data.content}
          onClick={() => {
            selectTrueFalse(item.data);
          }}
          isDisabled={isDisabled}
        />
      ))}
    </div>
  );
};

export default TrueFalse;
